<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14 6.99999C14 5.89699 13.103 4.99999 12 4.99999C10.897 4.99999 10 5.89699 10 6.99999C10 8.103 10.897 9 12 9C13.103 9 14 8.103 14 6.99999ZM16 7C16 9.206 14.206 11 12 11C9.794 11 8 9.206 8 7C8 4.794 9.794 3 12 3C14.206 3 16 4.794 16 7ZM5 20C5 16.14 8.141 13 12 13C15.859 13 19 16.14 19 20C19 20.552 18.553 21 18 21C17.447 21 17 20.552 17 20C17 17.243 14.757 15 12 15C9.243 15 7 17.243 7 20C7 20.552 6.553 21 6 21C5.447 21 5 20.552 5 20Z" fill="#4D646F"/>
  </svg>
</template>

<script>
export default {
  name: 'Person'
}
</script>

<style scoped>

</style>